import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKecamatan = 'kecamatan';
const postKecamatanUrl = 'kecamatan';
const putKecamatan = 'kecamatan/';
const deleteKecamatan = 'kecamatan/';

class KecamatanService {
    getKecamatan(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getKecamatan + '?pageNo=' + currentPage + '&pageSize='+pageSize+'&filter='+filter,
            {
                headers: authHeader()
            });
    }

    getAllKecamatan() {
        return axios.get(
            API_URL + getKecamatan + '?pageNo=0&pageSize=20000&filter=default',
            {
                headers: authHeader()
            });
    }

    postKecamatan(formData) {
        return axios
        .post(
            API_URL + postKecamatanUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKecamatan(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putKecamatan + formData.idKecamatan, formData,
            { headers: authHeader() }
        );
    }

    deleteKecamatan(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKecamatan + formData.idKecamatan,
                { headers: authHeader() }
            );
    }

}

export default new KecamatanService();